import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { PublicCheckout } from '@/api/publicEntities.js';
import { useExternalScript } from '../utils';

// Metaship Widget Wrapper
const MetashipWidget = ({ onPointSelect, fullAddress }) => {
  const { t } = useTranslation();
  const widgetContainerRef = useRef(null);
  const widgetInstanceRef = useRef(null);
  const [widgetKey, setWidgetKey] = useState(null);
  const [keyError, setKeyError] = useState(null);
  const scriptStatus = useExternalScript('https://widget.metaship.ru/v1/widget/load/v2');
  
  const widgetStyles = {
    marginTop: '10px',
    width: '100%',
    height: '650px',
    border: '1px solid #000',
  };

  // Fetch widget key
  useEffect(() => {
    const fetchWidgetKey = async () => {
      try {
        const result = await PublicCheckout.getMetashipWidgetKey();
        setWidgetKey(result.widgetKey);
      } catch (error) {
        setKeyError(error);
      }
    };

    fetchWidgetKey();
  }, []);

  useEffect(() => {
    // Initialize the widget only when both script and widget key are ready
    if (scriptStatus === 'ready' && widgetKey && window.MetaShipWidget && widgetContainerRef.current) {
        // Prevent re-initialization on re-renders
        if (widgetInstanceRef.current) {
            return;
        }

        const widget = new window.MetaShipWidget();
        widgetInstanceRef.current = widget;

        // Configure widget parameters
        widget.setParameter('widgetKey', widgetKey);
        widget.setParameter('size.minWeight', 1);
        widget.setParameter('size.minHeight', 10);
        widget.setParameter('size.minWidth', 10);
        widget.setParameter('size.minLength', 10);
        widget.setParameter('deliveryServiceCodes', ['Cdek']);
        widget.setParameter('mapZoom', 10);
        // widget.setParameter('countryCodes', ['RU', 'KZ', 'BY']);
        // widget.setParameter('availableFilters', ['dress-fitting']);
        widget.setParameter('fullAddress', fullAddress || undefined);

        widget.insert(widgetContainerRef.current);

        widget.on('callback', (point) => {
            console.log('Point selected:', point);
            if (onPointSelect) {
                onPointSelect(point);
            }
        });
    }

    // Cleanup: This runs when the component unmounts
    return () => {
      if (widgetInstanceRef.current) {
        console.log('Destroying Metaship widget.');
        widgetInstanceRef.current.destroy();
        widgetInstanceRef.current = null;
      }
    };
    // Re-run the effect if dependencies change
  }, [scriptStatus, widgetKey, onPointSelect]);

  // Render different UI based on loading status
  if (scriptStatus === 'loading' || !widgetKey) {
    return <div>{t('checkout.widget.loading')}</div>;
  }
  if (scriptStatus === 'error' || keyError) {
    return <div>{t('checkout.widget.error')}</div>;
  }
  
  // If everything is ready, render the container div for the widget.
  return <div ref={widgetContainerRef} style={widgetStyles} />;
};

export default MetashipWidget;